import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { RouterProvider } from "react-router-dom";
import { notification, message } from "antd";
import { AppProviders } from "@/app/providers";
import router from "@/app/router";

dayjs.extend(relativeTime);

notification.config({
  placement: "top",
  duration: 4.5,
  maxCount: 3,
  top: 24,
});

message.config({
  duration: 3,
  maxCount: 2,
});

export default function App() {
  return (
    <AppProviders>
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </AppProviders>
  );
}
